// const languagesObject = import('@/components/shared/generateLanguages');
// import languagesObject from '@/components/shared/generateLanguages';

const constants = {
  LESSON_TYPES: {
    CHATBOT_GOAL_GROUP: 'chatbot_goal_group',
    CHECKPOINT: 'checkpoint',
    DAILY_ENGLISH: 'daily_english',
    GRAMMAR: 'grammar',
    LESSON: 'lesson',
    MONSTER: 'monster',
    OVERALL_LESSON: 'overall_lesson',
    TUTORIAL_MONSTER: 'turorial_monster',
    EXPRESSION_LEARNER: 'expression_learner',
    PLACEMENT_TEST: 'placement_test',
    EXPRESSION_EXERCISE: 'expression_exercise',
    BONUS_LESSON: 'bonus_lesson',
  },
  LESSON_FLOWS: {
    STORED_LESSON: 'stored_lesson',
    EXPRESSIONS: {
      ALL_PASSIVE: 'all/passive',
      ALL_ACTIVE: 'all/active',
      ALL_UNKNOWN: 'all/unknown',
      FAVOURITE_PASSIVE: 'favourite/passive',
      FAVOURITE_ACTIVE: 'favourite/active',
      FAVOURITE_UNKNOWN: 'favourite/unknown',
    },
  },
  EXPRESSIONS: {
    TYPES: {
      UNKNOWN: 'unknown',
      PASSIVE: 'passive',
      ACTIVE: 'active',
    },
    FAVOURITE: 'favourite',
    ALL: 'all',
  },
  USER_SCOPES: {
    USER: 'user',
    LEAGUE: 'league',
    FRIENDS: 'friends',
    RESULTS: 'my_results',
    STATISTICS: 'statistics',
    LANGUAGE_PROGRESS: 'language_progress',
    AVATARS: 'avatars',
  },
  keyboardAddition: {
    de: ['a', 'ö', 'ü', 'ss'],
    es: ['aa', 'ee', 'ii', 'ny', 'oo', 'uu', 'ue', 'qm', 'em'],
    fr: [
      'ai',
      'ak',
      'au',
      'ae',
      'sz',
      'ee',
      'ei',
      'ek',
      'ep',
      'ip',
      'ik',
      'ok',
      'oe',
      'ui',
      'uk',
    ],
  },
};

export default constants;
